import useStore from '@/store/use-store';
import { Box, Button, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import Page from '../components/Page';
import PulsatingDots from '../components/PulsatingDots';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 520,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center',
  padding: theme.spacing(12, 0)
}));

export default function VerifyEmail() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const verifyEmail = useStore((state) => state.verifyEmail);
  const [status, setStatus] = useState('loading'); // loading | success | error
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [searchParams, verifyEmail]);

  return (
    <Page title={t('verify_email.title')}>
      <Container>
        <ContentStyle>
          {status === 'loading' && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <PulsatingDots size={15} />
            </Box>
          )}

          {status === 'success' && (
            <>
              <Typography variant="h4" gutterBottom>
                {t('verify_email.success_title')}
              </Typography>
              <Typography sx={{ color: 'text.secondary', mb: 4 }}>
                {t('verify_email.success_body')}
              </Typography>
              <Button variant="contained" component={RouterLink} to="/login">
                {t('login')}
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <Typography variant="h4" gutterBottom>
                {t('verify_email.error_title')}
              </Typography>
              <Typography sx={{ color: 'text.secondary', mb: 4 }}>
                {t('verify_email.error_body')}
              </Typography>
              <Button variant="contained" component={RouterLink} to="/login">
                {t('login')}
              </Button>
            </>
          )}
        </ContentStyle>
      </Container>
    </Page>
  );
}
